module.exports = __webpack_public_path__ + "img/google-logo.f6ce5696.svg";